import { render, staticRenderFns } from "./RelatedProductSlide.vue?vue&type=template&id=22c01566"
import script from "./RelatedProductSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatedProductSlide.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports